export default __webpack_public_path__ + "static/media/rsvp-separator.b1ebb141.svg";